export default "__VITE_ASSET__CYrpRhCu__"